import { render, staticRenderFns } from "./AttributeForm.vue?vue&type=template&id=ba012b00"
import script from "./AttributeForm.vue?vue&type=script&lang=js"
export * from "./AttributeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports